import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { TaskTimer } from '../../data-services/task-timer/task-timer.model';
import * as TaskTimerActions from './task-timer.actions';

export const taskTimersFeatureKey = 'taskTimers';

export interface State extends EntityState<TaskTimer> {
    // additional entities state properties
}

export const adapter: EntityAdapter<any> =
    createEntityAdapter<TaskTimer>({
        selectId: (model: TaskTimer) => `${model.empauthid}-${model.timerid}`
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

export const taskTimerReducer = createReducer(
    initialState,
    on(TaskTimerActions.addTaskTimer, (state, action) =>
        adapter.addOne(action.taskTimer, state)
    ),
    on(TaskTimerActions.upsertTaskTimer, (state, action) =>
        adapter.upsertOne(action.taskTimer, state)
    ),
    on(TaskTimerActions.addTaskTimers, (state, action) =>
        adapter.addMany(action.taskTimers, state)
    ),
    on(TaskTimerActions.upsertTaskTimers, (state, action) =>
        adapter.upsertMany(action.taskTimers, state)
    ),
    on(TaskTimerActions.updateTaskTimer, (state, action) =>
        adapter.updateOne(action.taskTimer, state)
    ),
    on(TaskTimerActions.updateTaskTimers, (state, action) =>
        adapter.updateMany(action.taskTimers, state)
    ),
    on(TaskTimerActions.deleteTaskTimer, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(TaskTimerActions.deleteTaskTimers, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(TaskTimerActions.loadTaskTimers, (state, action) =>
        adapter.setAll(action.taskTimers, state)
    ),
    on(TaskTimerActions.clearTaskTimers, state => adapter.removeAll(state))
);

export function reducer(state: State | undefined, action: Action) {
    return taskTimerReducer(state, action);
}

export const selectTaskTimerState =
    createFeatureSelector<State>(taskTimersFeatureKey);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectTaskTimerState);
